export default "__VITE_ASSET__3ef6eefe__"